import { memo } from 'react';
import { format } from 'date-fns';
import {
  InfoIcon,
  IconWrapper,
  LabelContainer,
  ConfirmButtonBox,
} from './bookNewSessionTabStyled';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { dateFormatYMD } from 'constants';
import MDTypography from 'components/MDTypography';
import { ButtonSpinner } from 'components/Ui/styled';
import { ButtonSpinnerProgress } from 'components/Ui/styled';

export const StatusLabel = ({ icon, text, message }) => {
  return (
    <LabelContainer component="span">
      <IconWrapper>{icon}</IconWrapper>
      {text}
      {message && <InfoIcon title={message}>ⓘ</InfoIcon>}
    </LabelContainer>
  );
};

export const getSubjectName = (subjects, subjectId) => {
  if (!subjectId) return '';

  const found = subjects?.find((s) => s.subjectId === subjectId);

  return found?.name || subjectId;
};

export const formatDisplayDate = (date) => {
  if (!date) return '';
  try {
    return format(new Date(date), dateFormatYMD);
  } catch {
    return date;
  }
};

export const ConfirmSubmitButton = ({
  onSubmit,
  handleSubmit,
  loading = false,
  isBooked = false,
  cancelText = 'Confirm Cancel',
  confirmText = 'Confirm Booking',
}) => {
  return (
    <ButtonSpinner>
      <ConfirmButtonBox>
        <Button
          variant="text"
          onClick={handleSubmit(onSubmit)}
          disabled={loading}
        >
          {isBooked ? cancelText : confirmText}
        </Button>

        {loading && <ButtonSpinnerProgress size={24} />}
      </ConfirmButtonBox>
    </ButtonSpinner>
  );
};

export const SessionItem = memo(({ session }) => (
  <Grid item xs={12} sm={6} md={4}>
    <MDTypography variant="button" fontWeight="bold">
      • {session?.date}, {session?.startTimeFmt}-{session?.endTimeFmt} (
      {session?.subjectName})
    </MDTypography>
  </Grid>
));
